'use client'

import React from 'react'
import { Container } from '@quark/layout'
import { Text } from '@quark/typography'
import { Animations, MultiReveal, Reveal } from '@quark/animation'
import isMobile from 'ismobilejs'
import styles from './ourImpactSection.module.scss'

const OurImpactSection = data => {
  const isMobileDevice = isMobile()?.phone

  return (
    <Container
      type="root"
      paddingTop={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      paddingBottom={{ lg: 'spacing-72', md: 'spacing-56', sm: 'spacing-40' }}
      paddingRight="spacing-16"
      paddingLeft="spacing-16">
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
        <Text as="p" fontStyle="um_text-base/normal" color="base/primary" textAlign="center">
          {data?.title}
        </Text>
        <Container paddingTop="spacing-16" paddingBottom="spacing-48">
          <Text
            as="p"
            fontStyle={{ lg: 'um_text-5xl/bold', md: 'um_text-4xl/bold', sm: 'um_text-3xl/bold' }}
            color="base/primary"
            textAlign="center">
            <span dangerouslySetInnerHTML={{ __html: data?.subtitle || '' }} />
          </Text>
        </Container>
      </Reveal>
      <Reveal as="span" animationProps={{ threshold: 0.1, animationDelayMs: 200 }}>
        <MultiReveal
          as="div"
          animationDelays={(i: number) => 300 + i * 100}
          className={styles.impactCardsGrid}
          animationProps={{ animation: Animations.FadeIn50px }}>
          {data?.impactCardList?.map((impact, index) => (
            <div
              className={styles.impactCardContainer}
              data-count={data?.impactCardList?.length}
              key={index}
              style={{
                backgroundImage: `url(${isMobileDevice ? impact?.mobileIconUrl?.url : impact?.iconUrl?.url})`,
              }}>
              <div className={styles.textContent}>
                <Container paddingBottom="spacing-4">
                  <Text
                    as="p"
                    fontStyle={{ lg: 'um_text-5xl/bold', md: 'um_text-3xl/bold', sm: 'um_text-2xl/bold' }}
                    color="static/Primary-onDark">
                    {impact?.title}
                  </Text>
                </Container>
                <Text
                  as="p"
                  fontStyle={{ lg: 'um_text-2xl/normal', md: 'um_text-lg/normal', sm: 'um_text-base/normal' }}
                  color="static/Primary-onDark">
                  {impact?.subtitle}
                </Text>
              </div>
              <div className={styles.gradient} />
            </div>
          ))}
        </MultiReveal>
      </Reveal>
    </Container>
  )
}

export default OurImpactSection
